import { render } from "./red-complex.vue?vue&type=template&id=7bdf71e6&scoped=true"
import script from "./red-complex.vue?vue&type=script&lang=js"
export * from "./red-complex.vue?vue&type=script&lang=js"

import "./red-complex.vue?vue&type=style&index=0&id=7bdf71e6&scoped=true&lang=css"

import exportComponent from "E:\\vue_yclcp\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7bdf71e6"]])

export default __exports__